import React from 'react';
import {
  Container,
  Paper,
} from '@mui/material';
import AIAssistantWithHistory from '../components/AIAssistantWithHistory';

const AIAssistantPage = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 3, height: 'calc(100vh - 120px)' }}>
      <Paper sx={{ height: '100%', minHeight: '600px' }}>
        <AIAssistantWithHistory />
      </Paper>
    </Container>
  );
};

export default AIAssistantPage;
